import { render, staticRenderFns } from "./AboutCantusMundi.vue?vue&type=template&id=66582460&scoped=true&"
import script from "./AboutCantusMundi.vue?vue&type=script&lang=ts&"
export * from "./AboutCantusMundi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66582460",
  null
  
)

export default component.exports